import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UsersListModule } from '../shared/users-list/users-list.module';
import { UsersListComponent} from '../shared/users-list/users-list.component';

 const routableModules = [
    UsersListModule
]

export const routes: Routes = [
  {path:'', pathMatch: 'full', redirectTo: 'user-list' },
  {path:'user-list', component: UsersListComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)
  ,routableModules],
  exports: [RouterModule]
})
export class ManageUsersRoutingModule { }
